"use strict";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UNKNOWN_ERROR = exports.INTERNAL_ERROR_MESSAGES = exports.ERROR_MESSAGE_TOKEN_PATTERN = void 0;
var ERROR_MESSAGE_TOKEN_PATTERN = exports.ERROR_MESSAGE_TOKEN_PATTERN = RegExp("\\{(\\d+)\\}", "gu");
/**
 * Code for an unknown error. You should never use nor encounter this error code.
 */ var UNKNOWN_ERROR = exports.UNKNOWN_ERROR = 'UNKNOWN_ERROR';
var INTERNAL_ERROR_MESSAGES = exports.INTERNAL_ERROR_MESSAGES = _define_property({}, UNKNOWN_ERROR, 'An unknown error has occurred.'); //# sourceMappingURL=constants.js.map
